import React from "react";
import PropTypes from "prop-types";
import { VERSION_SEPARATOR } from "./infoDocuments";
import "./infoMenu.css";

/**
 * The version exactly as versionLabel() spells it, but each part kept on one
 * line: a narrow column may wrap between release and build, never inside a
 * date or a commit ID, and the separator moves down with the build.
 */
const VersionText = ({ parts }) =>
  parts.map((part, index) => (
    <React.Fragment key={part}>
      {index > 0 && " "}
      <span className="info-version-part">
        {index > 0 && VERSION_SEPARATOR.trimStart()}
        {part}
      </span>
    </React.Fragment>
  ));

VersionText.propTypes = {
  parts: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default VersionText;
